// extracted by mini-css-extract-plugin
export default {"envelopeKnob":"Knob_envelopeKnob__mXsyT","knobValue":"Knob_knobValue__f5T+f","type":"Knob_type__snKhn"};